import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction } from '../service'

import { useForm } from 'react-hook-form'

export function AddCharge(props: { onClose: () => void; onSave: (action: EditOrderAction) => void }): JSX.Element {
  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      name: '',
      price: 0,
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any): void => {
    props.onSave({ op: 'add-charge', charge: { amount: data.price, name: data.name } })
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Add Charge</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              id="name"
              className="form-control input input-small"
              style={errors && errors.name ? { color: 'red' } : {}}
              type="text"
              {...register('name', {
                required: 'is required',
              })}
            />
            {errors && errors.name && <span className="text-danger">{errors.name.message}</span>}
          </div>
          <div className="form-group">
            <label htmlFor="price">Amount:</label>
            <input
              id="price"
              className="form-control input input-small"
              style={errors && errors.price ? { color: 'red' } : {}}
              type="number"
              step={0.01}
              {...register('price', {
                required: 'is required',
                min: { value: 0.01, message: 'must be greater than 0' },
                valueAsNumber: true,
              })}
            />
            {errors && errors.price && <span className="text-danger">{errors.price.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
